import {
    GET_EXCEL,
    CLEAN_CASOS,
    SET_QUERY_STATE
} from '../types';


export default function consulta360Reducer(state = {}, action) {
    switch (action.type) {
        case GET_EXCEL:
            return { ...state, excel:action.payload }
        case CLEAN_CASOS:
            return { ...state, consultaCasos:{} }
        case SET_QUERY_STATE:
            return { ...state, myQueryStateGlobal:action.payload }                 
       
        default:
            return state
    }
}